/**
 * @generated SignedSource<<e1bb893e60b62d409b21b5c278e1ec5d>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PredictPrintAreasInput = {
  confidence?: number | null;
  imageUrl: string;
  includeAnnotatedImage?: boolean | null;
};
export type variantsPredictPrintAreasMutation$variables = {
  input: PredictPrintAreasInput;
};
export type variantsPredictPrintAreasMutation$data = {
  readonly predictPrintAreas: {
    readonly detections: ReadonlyArray<{
      readonly bboxPixels: {
        readonly height: number;
        readonly width: number;
        readonly x: number;
        readonly y: number;
      } | null;
      readonly confidence: number;
    }>;
    readonly error: string | null;
    readonly imageInfo: {
      readonly height: number;
      readonly ppcmAvg: number | null;
      readonly width: number;
    } | null;
    readonly success: boolean;
  };
};
export type variantsPredictPrintAreasMutation = {
  response: variantsPredictPrintAreasMutation$data;
  variables: variantsPredictPrintAreasMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "width",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "height",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PredictPrintAreasOutput",
    "kind": "LinkedField",
    "name": "predictPrintAreas",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PredictedPrintAreaImageInfo",
        "kind": "LinkedField",
        "name": "imageInfo",
        "plural": false,
        "selections": [
          (v1/*:: as any*/),
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "ppcmAvg",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PredictedPrintAreaDetection",
        "kind": "LinkedField",
        "name": "detections",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "confidence",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PredictedBoundingBox",
            "kind": "LinkedField",
            "name": "bboxPixels",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "x",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "y",
                "storageKey": null
              },
              (v1/*:: as any*/),
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "variantsPredictPrintAreasMutation",
    "selections": (v3/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "variantsPredictPrintAreasMutation",
    "selections": (v3/*:: as any*/)
  },
  "params": {
    "cacheID": "c9e71ed5b2bc6e127d802e82c86a9157",
    "id": null,
    "metadata": {},
    "name": "variantsPredictPrintAreasMutation",
    "operationKind": "mutation",
    "text": "mutation variantsPredictPrintAreasMutation(\n  $input: PredictPrintAreasInput!\n) {\n  predictPrintAreas(input: $input) {\n    success\n    error\n    imageInfo {\n      width\n      height\n      ppcmAvg\n    }\n    detections {\n      confidence\n      bboxPixels {\n        x\n        y\n        width\n        height\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c97d312497127be429e1a0a6afaed6ec";

export default node;
